import { call, delay, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { getErrorMessageFromAPI } from '../../../utilz';
import { setAppLoader } from '../../common/CommonActions';
import { getPreClaimsDuplicatesInError, getPreClaimsDuplicatesInSuccess } from './PreClaimsActions';
import { checkDuplicatePreClaimEffect, createPreClaimsEffect } from './PreClaimsEffects';
import PreClaimsTypes from './PreClaimsTypes';

function* createClaimWatcher({ payload: { handleDone, ...payload } }) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(createPreClaimsEffect, payload);

    if (handleDone) {
      handleDone(data);
    }
    yield put(setAppLoader(false));
  } catch {
    yield put(setAppLoader(false));
  }
}

function* getClaimDuplicatesWatcher({ payload: { handleDone, isInstantValidation, ...payload } }) {
  try {
    if (!isInstantValidation) {
      yield put(setAppLoader(true));
    } else {
      yield delay(1000); // To prevent often calls when while the invoice and pro no fields is blurred
    }
    const { data } = yield call(checkDuplicatePreClaimEffect, payload);

    yield put(
      getPreClaimsDuplicatesInSuccess({
        data,
      }),
    );
    if (handleDone) {
      handleDone(data);
    }
    if (!isInstantValidation) yield put(setAppLoader(false));
  } catch (error) {
    if (!isInstantValidation) yield put(setAppLoader(false));
    const message = getErrorMessageFromAPI(error, 'Failed to create Pre Claim');
    yield put(getPreClaimsDuplicatesInError({ message }));
  }
}

export default function* PreClaimsSaga() {
  yield takeEvery(PreClaimsTypes.CREATE_CLAIM_PROGRESS, createClaimWatcher);
  yield takeLatest(PreClaimsTypes.GET_CLAIM_DUPLICATES_PROGRESS, getClaimDuplicatesWatcher);
}
